<ng-container *ngIf="data">
  <img [src]="data.icon" />
  <span class="u-h6 title">{{ data.title | translate }}</span>
</ng-container>
